import TransportRequest from 'js/pages/transport-request/index.js'
import GeneralConditionsOfTransport from 'js/pages/general-conditions-of-transport/index.js'
import InstitutionalInformation from 'js/pages/institutional-information/index.js'
import cookiesPolicy from 'js/pages/cookies-policy-text/index.js'
import AccessibilityStatement from 'js/pages/accessibility-statement/index.js'
import PrivacyPolicyRoutes from 'js/pages/privacy-policy/index.js'

export default [
  {
    path: '/',
    name: 'home',
    redirect: { name: HOME_ROUTE },
  },
  {
    path: '/transport-request',
    name: 'transport-request',
    component: TransportRequest,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/general-conditions-of-transport',
    name: 'general-conditions-of-transport',
    component: GeneralConditionsOfTransport,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/institutional-information',
    name: 'institutional-information',
    component: InstitutionalInformation,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/cookies-policy-text',
    name: 'cookies-policy-text',
    component: cookiesPolicy,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/accessibility-statement',
    name: 'accessibility-statement',
    component: AccessibilityStatement,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicyRoutes,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  }
]